import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const ChatPage = lazy(() =>
  import("@/pages/chat").then((m) => ({ default: m.ChatPage }))
);

// Sem a feature a rota não existe (como o menu e a API): devolve ao painel.
const CHAT = { access: "authenticated" as const, feature: "platform.chat" as const };

export const chatRoutes: RouteConfig[] = [
  { path: ROUTES.CHAT, component: ChatPage, layout: "dashboard", permissions: CHAT },
];
